// https://material.io/tools/icons/?search=location&mdIcon=location_on&style=baseline

export const useCategories = [
  {
    text: 'Residential',
    value: 'residential',
    overallIcon: 'mdi-home',
    mdIcon: 'mdi-home',
    meta: 'Personal or professional use at home.',
    // https://www.pexels.com/photo/woman-wearing-tank-top-sitting-by-the-window-920381/
    bgImage: 'adult-brunette-communication-920381.jpg',
    gradient: 'to top right, rgba(0, 150, 214,.6), rgba(0,86,149,.6)',
  },
  {
    text: 'Business',
    value: 'business',
    overallIcon: 'mdi-domain',
    mdIcon: 'mdi-domain',
    meta: 'Business categories, such as a bar/restaurant, coffee shops, office/retail, or lodging.',
    // https://www.pexels.com/photo/two-men-sitting-facing-on-flat-screen-monitors-2451646/
    bgImage: 'adults-blond-hair-chairs-2451646.jpg',
    gradient: 'to top right, rgba(251, 176, 51,.5), rgba(0, 150, 214,.5)',
  },
];

export const scale = [
  {
    value: 'single',
    text: 'Single',
    number: 1,
    overallIcon: 'mdi-account-multiple',
    iconCount: 1,
    mdIcon: 'mdi-account-outline',
    description: 'As a single individual you control your demands on your internet connection. While you may have several devices, you know when they are connected and what they are doing',
  },
  {
    value: 'couple',
    text: 'Couple',
    number: 2,
    iconCount: 2,
    overallIcon: 'mdi-account-multiple',
    mdIcon: 'mdi-account-outline',
    description: 'Couples face some basic challenges around sharing an internet connection and can run into some challenges when one wants to stream movies while the other needs to work.',
  },
  {
    value: 'family',
    text: 'Family',
    number: 3,
    iconCount: 3,
    overallIcon: 'mdi-account-multiple',
    mdIcon: 'mdi-account-outline',
    description: 'As the number of people in the household grows, so does the demand on the internet – especially if you have kids trying to stream movies, play games, and do homework while you’re on a Skype call for work.',
  },
  {
    value: 'largerfamily',
    text: 'Larger Family',
    number: 5,
    iconCount: 5,
    overallIcon: 'mdi-account-multiple',
    mdIcon: 'mdi-account-outline',
    description: 'What happens when everyone in the house turns on the water at the same time? The same happens with the internet. With more users comes more demand, and to meet that you need a bigger internet circuit.',
  },
];

export const usePattern = [
  {
    value: 'typical',
    text: 'Typical',
    number: 15,
    overallIcon: 'mdi-speedometer',
    mdIcon: 'mdi-speedometer-slow',
    iconCount: 1,
    iconSize: 50,
    description: 'Normal everyday use including checking email, streaming music/TV, etc.'
  },
  {
    value: 'moderate',
    text: 'Moderate',
    number: 50,
    overallIcon: 'mdi-speedometer',
    mdIcon: 'mdi-speedometer-medium',
    iconCount: 1,
    iconSize: 50,
    description: 'More demanding uses such as gaming, video conferencing, and downloading/uploading small files.'
  },
  {
    value: 'heavy',
    text: 'Heavy',
    number: 100,
    overallIcon: 'mdi-speedometer',
    mdIcon: 'mdi-speedometer',
    iconCount: 1,
    iconSize: 50,
    description: 'Internet is used regularly in daily life/work including video conferencing, streaming, and/or the ' +
      'demands of moving medium sized files over the internet.'
  },
  {
    value: 'professional',
    text: 'Professional',
    number: 200,
    overallIcon: 'mdi-speedometer',
    mdIcon: 'mdi-professional-hexagon',
    iconCount: 1,
    iconSize: 50,
    description: 'Internet is a critical part of daily life/work. Large amounts of data are being moved, and/or ' +
      'speed is very important to ensure adequate operations.'
  },
];

export const businessType = [
  {
    value: 'barrestaurant',
    text: 'Bar/Restaurant',
    number: null,
    overallIcon: 'mdi-silverware-fork-knife',
    mdIcon: 'mdi-silverware-fork-knife', // local_bar
    iconCount: 1,
    iconSize: 50,
    description: 'Bars & restaurants typically don’t offer WiFi to their patrons, although having solid internet is likely an important part of doing business.',
  },
  {
    value: 'coffeeshop',
    text: 'Coffee Shop',
    number: null,
    overallIcon: 'mdi-coffee',
    mdIcon: 'mdi-coffee',
    iconCount: 1,
    iconSize: 50,
    description: 'Most coffee shops offer WiFi to customers as an attraction point allowing them to come in, get some food and drink, and do work.'
  },
  {
    value: 'officeretail',
    text: 'Office/Retail',
    number: null,
    overallIcon: 'mdi-office-building',
    mdIcon: 'mdi-office-building',
    iconCount: 1,
    iconSize: 50,
    description: 'Office spaces typically need high-quality internet connections to meet the demand of workers performing a variety of business functions.',
  },
  {
    value: 'lodging',
    text: 'Lodging',
    number: null,
    overallIcon: 'mdi-hotel',
    mdIcon: 'mdi-hotel',
    iconCount: 1,
    iconSize: 50,
    description: 'WiFi is seen as a differentiator within lodging properties where patrons expect to be able to connect to high-speed service on multiple devices.',
  },
];

export const businessSpeed = [
  {
    value: 'slower',
    text: 'Slower',
    number: {
      barrestaurant: 1,
      coffeeshop: 3,
      officeretail: 5,
      lodging: 3,
    },
    overallIcon: 'mdi-speedometer',
    mdIcon: 'mdi-speedometer-slow',
    iconCount: 1,
    iconSize: 50,
    description: 'This category allocates enough speed to do basic tasks such as check email and social media and is generally no more than {}.'
  },
  {
    value: 'medium',
    text: 'Medium',
    number: {
      barrestaurant: 5,
      coffeeshop: 15,
      officeretail: 50,
      lodging: 15,
    },
    overallIcon: 'mdi-speedometer',
    mdIcon: 'mdi-speedometer-medium',
    iconCount: 1,
    iconSize: 50,
    description: 'This category ensures that users are able to perform most business functions including streaming audio & video and is aimed at closer to {}.'
  },
  {
    value: 'fast',
    text: 'Fast',
    number: {
      barrestaurant: 10,
      coffeeshop: 30,
      officeretail: 200,
      lodging: 50,
    },
    overallIcon: 'mdi-speedometer',
    mdIcon: 'mdi-speedometer',
    iconCount: 1,
    iconSize: 50,
    description: 'This category describes professional use cases such as moving large amounts of data or similar functions and is typically set around {}.'
  },
];

export const county = [
  {
    color: 'grey lighten-2',
    value: 'both',
    text: 'Both',
    number: null,
    overallIcon: 'mdi-shape',
    mdIcon: 'stars',
    iconCount: null,
    description: 'Narrow down locations and communites by pre-selecting a county.'
  },
  {
    color: 'blue',
    value: 'mono',
    text: 'Mono',
    number: null,
    overallIcon: 'mdi-shape',
    mdIcon: 'stars',
    iconCount: null,
    description: 'Narrow down locations and communites by pre-selecting a county.'
  },
  {
    color: 'yellow darken-3',
    value: 'inyo',
    text: 'Inyo',
    number: null,
    overallIcon: 'mdi-shape',
    mdIcon: 'stars',
    iconCount: null,
    description: 'Narrow down locations and communites by pre-selecting a county.'
  },
];

export const dataModels = {
  useCategories,
  scale,
  usePattern,
  county,
  businessType,
  businessSpeed,
};

export default dataModels;
